import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetCarrierStatusTrackingListInput } from './GetCarrierStatusTrackingListInput';
import { GetCarrierStatusTrackingListOutput } from './GetCarrierStatusTrackingListOutput';

export class GetCarrierStatusTrackingListService extends HttpServiceBase {

  handle = (input?: GetCarrierStatusTrackingListInput): Promise<Result<GetCarrierStatusTrackingListOutput> | null> => {
    const url = input && input.carrierId ? `?carrierId=${input.carrierId}` : '';
    const promise = this.http.get<Result<GetCarrierStatusTrackingListOutput>>(`${this.baseUrlSislogApi}/v2/carrier/status-tracking-list${url}`);
    return promise;
  }
}